import {
  ADD_NEW_CLIENT_ERROR,
  ADD_NEW_CLIENT_SUCCESS,
  BULK_UPLOAD,
  BULK_UPLOAD_ERROR,
  BULK_UPLOAD_SUCCESS,
  CLIENT_DROPDOWN_FETCH,
  CLIENT_DROP,
  UPDATE_NEW_CLIENT,
  UPDATE_NEW_CLIENT_ERROR,
  UPDATE_NEW_CLIENT_SUCCESS,
  DELETE_CLIENT_SUCCESS,
  DELETE_CLIENT_ERROR,
  DELETE_CLIENT_BYID
} from "./actiontype";
import { ADD_NEW_CLIENT } from "./actiontype";
import {
  CLIENT_DATA,
  CLIENT_DATA_ERROR,
  CLIENT_DATA_SUCCESS,
  ALL_CLIENT_DATA_SUCCESS,
} from "./actiontype";


export const getClientsList = (params, download, exportname) => {
  return {
    type: CLIENT_DATA,
    payload: params,
    exports: download,
    exportname: exportname
  };
};

export const getClientdropdown = (params, download, exportname) => {
  return {
    type: CLIENT_DROP,
    payload: params,
    exports: download,
    exportname: exportname
  };
};
export const dropdownclientListSuccess = (response) => {
  return {
    type: CLIENT_DROPDOWN_FETCH,
    payload: response,
  };
};
export const clientListSuccess = (response) => {
  return {
    type: CLIENT_DATA_SUCCESS,
    payload: response,
  };
};

export const allClientListSuccess = (response) => {
  return {
    type: ALL_CLIENT_DATA_SUCCESS,
    payload: response,
  };
};

export const clientListError = (erordata) => {
  return {
    type: CLIENT_DATA_ERROR,
    payload: erordata,
  };
};
export const onAddnewClient = (params, callback) => {

  return {
    type: ADD_NEW_CLIENT,
    payload: params,
    callback,
  };
};
export const onAddnewClientSuccess = (response) => {
  return {
    type: ADD_NEW_CLIENT_SUCCESS,
    payload: response,
  };
};
export const onAddnewClientError = (erordata) => {
  return {
    type: ADD_NEW_CLIENT_ERROR,
    payload: erordata,
  };
};
export const onupdateClient = (params, callback) => {
  return {
    type: UPDATE_NEW_CLIENT,
    payload: params,
    callback,
  };
};
export const onupdateClientSuccess = (response) => {
  return {
    type: UPDATE_NEW_CLIENT_SUCCESS,
    payload: response,
  };
};
export const onupdateClientError = (erordata) => {
  return {
    type: UPDATE_NEW_CLIENT_ERROR,
    payload: erordata,
  };
};
export const onDeleteclient = (userId, callback) => {
  return {
    type: DELETE_CLIENT_BYID,
    payload: userId,
    callback,
  };
};
export const onDeleteclientSuccess = (mess) => {
  return {
    type: DELETE_CLIENT_SUCCESS,
    payload: mess,
  };
};

export const onDeleteclientError = (mess) => {
  return {
    type: DELETE_CLIENT_ERROR,
    payload: mess,
  };
};
// export const postuploadData = (params, callback) => {
//   return {
//     type: BULK_UPLOAD,
//     payload: params,
//     callback,
//   };
// };
// export const postuploadDataSuccess = (response) => {
//   return {
//     type: BULK_UPLOAD_SUCCESS,
//     payload: response,
//   };
// };
// export const postuploadDataError = (erordata) => {
//   return {
//     type: BULK_UPLOAD_ERROR,
//     payload: erordata,
//   };
// };
